import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import downloadSuccess from "../../../../assets/images/Reports/downloadSuccess.svg";
import "../../../../stylesheets/components/Reports/HoldingReports/SmcasePopupSuccess.scss";
import downloadPopup from "@frameworks/web/assets/images/Reports/common/download-popup.svg";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { useSelector } from "react-redux";
const SuccessPopup = (props) => {
    var _a;
    const navigate = useNavigate();
    const { loginOrigin } = useParams();
    const salesNativeApp = JSON.parse(localStorage.getItem("sales_native_app"));
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginOrigin !== LoginSource.SALES &&
        !salesNativeApp &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const setUrl = () => {
        const destination = ".." +
            getLoginSourceURL(loginOrigin) +
            "?reportName=" +
            props.pageName.replace(/\s/g, "") +
            (props.tabName ? "&tab=" + props.tabName : "");
        navigate(destination, { replace: true });
    };
    return (React.createElement("div", { className: `smallcase-popup-success ${!isClientLogin && "not-client-login"}` },
        React.createElement("div", { className: "smallcase-popup-success-head" },
            (props === null || props === void 0 ? void 0 : props.isDownloadIcon) && (React.createElement(React.Fragment, null,
                React.createElement("img", { src: downloadPopup, className: "head-icon pe-2" }))),
            (props === null || props === void 0 ? void 0 : props.isDownload) ? "Download" : "",
            " ",
            props.Title,
            " ",
            !props.reportText && "Report"),
        React.createElement("div", { className: "smallcase-popup-success-body" },
            props.operation == "email_download" || props.operation == "email" ? (React.createElement("img", { className: "downloadSuccess", src: downloadSuccess, alt: "Email Successful" })) : props.operation == "download" ? (React.createElement("img", { className: "downloadSuccess", src: downloadSuccess, alt: "Download Successful" })) : null,
            ((_a = props === null || props === void 0 ? void 0 : props.Title) === null || _a === void 0 ? void 0 : _a.toUpperCase().includes("Sqaure off For Position".toUpperCase())) && (React.createElement("img", { className: "downloadSuccess", src: downloadSuccess, alt: "Download Successful" })),
            props.messageReactNode ? (React.createElement(React.Fragment, null,
                props.messageReactNode,
                !isClientLogin && !props.disablePnPassword && (React.createElement(PANPassword, { reportText: props === null || props === void 0 ? void 0 : props.aifPdfText })))) : (React.createElement("label", { className: "update-message" }, props.message ? (React.createElement(React.Fragment, null,
                React.createElement("span", { dangerouslySetInnerHTML: { __html: props.message } }),
                !isClientLogin && !props.disablePnPassword && (React.createElement(PANPassword, { reportText: props === null || props === void 0 ? void 0 : props.aifPdfText })))) : (React.createElement(React.Fragment, null,
                "Your request was successfully processed.",
                !isClientLogin && !props.disablePnPassword && (React.createElement(PANPassword, { reportText: props === null || props === void 0 ? void 0 : props.aifPdfText })))))),
            React.createElement("span", { className: "action-post-success" },
                React.createElement("button", { onClick: () => {
                        var _a;
                        props.setDownloadSuccess(false);
                        setTimeout(() => {
                            var _a;
                            (_a = props === null || props === void 0 ? void 0 : props.closeDropdown) === null || _a === void 0 ? void 0 : _a.call(props, false);
                        }, 0);
                        if (props === null || props === void 0 ? void 0 : props.sendBack) {
                            (_a = props === null || props === void 0 ? void 0 : props.goBack) === null || _a === void 0 ? void 0 : _a.call(props);
                        }
                        else {
                            setUrl();
                        }
                        // window.location.reload();
                    } },
                    React.createElement("i", { className: "edel-icon-left-shortArrow twist" }),
                    props.goBackText ? "Go Back" : `Go Back To ${props.pageName}`)))));
};
export default SuccessPopup;
